export default "__VITE_ASSET__DOZtF5N___"